/* eslint-disable no-unused-expressions */
/* eslint-disable no-undef */
export class PopupList {
	constructor(data) {
		this.data = data;
		this.popup = document.querySelector('.popup-list');
		this.targetField = document.querySelector('.map__icon');
		this.targetField.addEventListener('click', this.handler.bind(this));
		this.location = document.querySelector('.popup-list__title');
		this.isMobile = window.innerWidth < 850;
	}

	getContent(target) {
		let oldResult = document.querySelector('.popup-list__result');
		let newResult = document.createElement('div');
		let targetId = target.id;

		// исключения для регионов где нельзя из области получить город
		switch (target.id) {
			case 'primorsky-krai': targetId = 'vladivostok';
				break;
			case 'ru-kr-obl': targetId = 'ru-kr';
				break;
			case 'hmao': targetId = "hmao-kogalym";
				break;
			case 'tatarstan': targetId = "tatarstan-kazan";
				break;
			case 'mordoviya': targetId = 'saransk';
				break;
			case 'mariy-el-yoshkar-ola': targetId = "mariy-el";
				break;
			case 'krym': targetId = 'sevastopol';
				break;
			case 'samarskaya-obl': targetId = "samarskaya-obl-samara";
				break;
			case 'spb-obl': targetId = 'spb';
				break;
			case 'moscow-obl': targetId = 'moscow';
				break;
			case 'sverdlovskaya-obl': targetId = "sverdlovskaya-obl-ekaterinburg";
				break;
			case 'kbr': targetId = "kbr-nalchik";
				break;
			default: break;
		}

		oldResult.remove();
		newResult.classList.add('popup-list__result');
		this.popup.appendChild(newResult);
		this.location.innerText = target.dataset.name;

		this.data.forEach((el) => {
			const targetIdEdit = targetId.split('-');

			const actionForPopupList = () => {
				const newItem = document.createElement('div');
				newItem.classList.add('popup-list__item');
				newItem.dataset.id = el.id;
				newItem.dataset.location = target.id;
				newItem.dataset.locationName = target.dataset.name;
				newItem.dataset.type = el.type;

				if (el.parentId) {
					newItem.dataset.parentId = el.parentId;
				}
				newItem.innerHTML = `
					<div class="popup-list__item-name">${el.name}</div>
					<div class="popup-list__item-position">${el.location}</div>
				`;

				newResult.appendChild(newItem);
			};

			if (targetIdEdit.length === 3 || targetIdEdit.length === 1) {
				if (targetId === el.locationId) {
					actionForPopupList();
				}
			} else if (targetIdEdit.length === 2) {
				if (targetIdEdit[0] === el.locationId.split('-')[0]) {
					actionForPopupList();
				}
			}
		});

		setTimeout(() => {
			const maxHeight = parseInt(getComputedStyle(newResult).maxHeight);
			if (newResult.scrollHeight <= maxHeight) {
				newResult.style.overflow = "initial";
			} else {
				newResult.style.overflow = "";
			}
		}, 0);

		this.checkOnlyBranch();
	}

	checkOnlyBranch() {
		const result = document.querySelectorAll('.popup-list__item');
		const branchItems = this.popup.querySelectorAll('[data-type="branch"]');
		const title = document.querySelector('.popup-list__title');

		if (result.length === 1 && result[0].dataset.type === 'branch') {
			// title.innerHTML = 'Филиал музея';
			this.popup.classList.add('branch');
		} else if (result.length === branchItems.length) {
			this.popup.classList.add('branch');
			// title.innerHTML = 'Филиалы музея';
		} else {
			this.popup.classList.remove('branch');
		}
	}

	open(e, target) {
		if (!(e.target.id === 'moscowOld' || e.target.id === 'spbOld')) {
			this.getContent(target);

			const posX = e.clientX;
			const posY = e.clientY;

			this.popup.style.display = 'block';
			this.popup.style.left = `${posX - 140}px`;

			if (posY - this.popup.offsetHeight - 16 + window.scrollY <= 0) {
				this.popup.style.top = 0;
			}	else {
				this.popup.style.top = `${posY - this.popup.offsetHeight + window.scrollY}px`;
			}
		}
		ga('send', 'event', 'map', 'show museum list', e.target.getAttribute('data-name'));
	}

	close() {
		this.popup.classList.remove('branch');
		this.popup.style.display = 'none';
	}

	handler(e) {
		if (!this.isMobile) {
			if (e.target.id && e.target.classList.contains('active')) {
				this.open(e, e.target);
			} else {
				this.close();
			}
		}
	}
}
